import { toTruncated } from '@simplywallst/formatting';
import type { ProviderType } from '@/components/OurPlans/types';
import { differenceInMinutes } from 'date-fns';
import type { BillingPeriod } from './constants';
import type { PlanType } from '@simplywallst/services';

export const isPaidPlan = (planType: PlanType): boolean => {
  return ['premium', 'unlimited'].includes(planType);
};

export const isLegacyPlan = (
  planType: PlanType
): planType is Exclude<PlanType, 'free' | 'premium' | 'unlimited'> => {
  return (
    planType !== 'free' && planType !== 'premium' && planType !== 'unlimited'
  );
};

export const shouldSeeSubscriptionModal = (
  hasSeenModal: boolean,
  currentPeriodStart: number,
  plan: PlanType,
  provider: ProviderType
): boolean => {
  if (
    hasSeenModal ||
    currentPeriodStart <= 0 ||
    plan !== 'unlimited' ||
    provider !== 'stripe'
  ) {
    return false;
  }
  const newPlansReleaseDate = new Date(2021, 1, 8, 14, 10);
  const isLegacyUser =
    differenceInMinutes(currentPeriodStart, newPlansReleaseDate) < 0;
  return isLegacyUser;
};

export const getDiscountedPlanAmount = (
  planAmount: number,
  percentOff: number
) => {
  return planAmount * (1 - percentOff);
};

export const formatMonthlyPrice = (
  amount: number,
  billingPeriod: BillingPeriod,
  currencyISO: string
): string => {
  const monthlyPrice = amount / (billingPeriod === 'year' ? 12 : 1);
  const currencySymbol = currencyISO === 'GBP' ? '£' : '$';
  return `${currencySymbol}${toTruncated(
    monthlyPrice,
    monthlyPrice % 1 === 0 ? 0 : 2
  )}`;
};

export const formatTotalPrice = (
  amount: number,
  currencyISO: string
): string => {
  const currencySymbol = currencyISO === 'GBP' ? '£' : '$';
  return `${currencySymbol}${toTruncated(amount, amount % 1 === 0 ? 0 : 2)}`;
};
